import React, { useState, useMemo } from 'react'
import { useSetRecoilState } from 'recoil'
import { navigate } from 'gatsby'
import { Col, Row } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { Loading } from '/src/components/loading'
import { Button, TextInput } from '/src/components/common'
import { BillingAddressElement } from '/src/components/commerce/form/elements'
import { cartCountState, cartState } from '/src/hooks/useCart'
import { postRequest } from '/src/httpClient'

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
})

export const PaymentPaneTradeForm = ({ cart, user }) => {
  const [message, setMessage] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const setCartState = useSetRecoilState(cartState)
  const setCartCountState = useSetRecoilState(cartCountState)
  const { register, watch, control, setValue, getValues, handleSubmit } = useForm({
    defaultValues: {
      payment_method: 'credit',
    }
  })
  const hasBillingAddress = useMemo(() => getValues('select_address') ? true : false, [getValues('select_address')])

  const onSubmit = (data) => {
    setIsLoading(true)

    // Submit credit payment.
    postRequest('/api/credit/payment', {
      data: {
        order_id: cart.id,
        po_number: data.po_number
      }
    }).then(response => {
      if (response) {
        setCartState(false)
        setCartCountState(0)
        navigate(`/checkout/complete/${cart.id}`)
      } else {
        // credit payment failed.
        setMessage('Credit payment failed, please contact your account manager.')
      }

      setIsLoading(false)
    })
  }

  return (
    <div className="payment-form-container">
      <form id="payment-pane-form" onSubmit={handleSubmit(onSubmit)}>
        <div className="form-item mb-4">
          <BillingAddressElement 
            label="Billing Address"
            cart={cart}
            user={user}
            control={control} 
            register={register}
            setValue={setValue}
            getValues={getValues}
            watch={watch}
          />
        </div>
        {!hasBillingAddress && (
          <div className='form-item mb-4'>
            <p>Please select billing information before entering payment details.</p>
          </div>
        )}
        <div className="form-item-radios payment-method mb-4">
          <label className="mb-2">Payment Method</label>
          <Row>
            <Col sm={6} md={4}>
              <div className="form-item radio">
                <label>
                  Customer Credit
                  <input type="radio" value="credit" {...register('payment_method')} />
                </label>
              </div>
            </Col>
          </Row>
        </div>
        {message && (
          <div className="form-item message mb-4">
            {message}
          </div>
        )}
        <div className="credit-input-element-container">
          <Row>
            <Col sm={12}>
              <TextInput 
                label="Account Name" 
                value={user.trade_name}
                register={register('account_name', {
                  disabled: true
                })} />
            </Col>
            <Col sm={12}>
              <TextInput 
                label="Credit Available"
                value={formatter.format(user.credit)}
                register={register('credit_available', {
                  disabled: true
                })} />
            </Col>
            <Col sm={12}>
              <TextInput 
                label="PO Number" 
                register={register('po_number', {
                  required: true
                })} />
            </Col>
          </Row>
        </div>

        <Button disabled={isLoading || !hasBillingAddress} variant="primary" type="submit">
          Pay Now
          {isLoading ? <Loading /> : null}
        </Button>
      </form>
    </div>
  )
}

export default PaymentPaneTradeForm
